import { render } from "./ContentCreateComponent.vue?vue&type=template&id=426aa0a3&scoped=true"
import script from "./ContentCreateComponent.vue?vue&type=script&lang=js"
export * from "./ContentCreateComponent.vue?vue&type=script&lang=js"

import "./ContentCreateComponent.vue?vue&type=style&index=0&id=426aa0a3&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426aa0a3"]])

export default __exports__